import { useMemo } from 'react';

import { QueryParameter } from '@farmersdog/constants';

import { CardName } from '../blueprint/types';
import { useQueryParams } from '../components/NewTosaRouter/hooks/useQueryParams';

export const useBlueprintStepsToSkip = (): CardName[] => {
  const queryParams = useQueryParams();
  const shouldSkipGetStarted =
    queryParams.get(QueryParameter.SkipGetStarted) === 'true';

  return useMemo(
    () => (shouldSkipGetStarted ? [CardName.GetStarted] : []),
    [shouldSkipGetStarted]
  );
};
